import {closeAllPopups, disableAds, refreshAds} from "../../functions";

document.addEventListener("DOMContentLoaded", function (event) {
    const createAccountPopupId = 'createAccountPopup';
    const popupElement = document.getElementById(`${createAccountPopupId}`);
    if (popupElement === null) return;

    const emailElement = popupElement.querySelector('#email');
    const codeElement = popupElement.querySelector('#code');
    const profileElement = document.querySelector('#profile');
    const avatarElement = document.querySelector('#avatar');
    const firstStepElements = popupElement.querySelectorAll('[data-display-on-step1]');
    const secondStepElements = popupElement.querySelectorAll('[data-display-on-step2]');
    const changeEmailElement = document.querySelector(`#${createAccountPopupId} [data-change-email]`);
    const resendCodeElement = document.querySelector(`#${createAccountPopupId} [data-resend-code]`);
    const resendCodeElementTimer = resendCodeElement.querySelector('span');
    const loginPath = `${location.protocol}//${location.hostname}/${location.pathname.split('/')[1]}/${location.pathname.split('/')[2]}/${location.pathname.split('/')[3]}/login`;
    let resetCountdownId = undefined;

    showCreateAccountPopup();
    hideCreateAccountPopup();
    submitHandler();
    changeEmailHandler();
    resendCodeHandler();

    function submitHandler() {
        document.querySelector(`#${createAccountPopupId} button`).addEventListener('click', function (event) {
            event.preventDefault();

            if (emailElement.disabled === true && codeElement.value.length !== 0) {
                fetch(`${loginPath}?email=${btoa(emailElement.value)}&code=${btoa(codeElement.value)}`)
                    .then(response => {
                        if (response.ok) {
                            response.json().then(data => {
                                if (typeof data == 'object') {
                                    document.querySelector('[data-modal-login]').classList.toggle('hidden');
                                    document.querySelector('[data-profile]').classList.toggle('hidden');

                                    profileElement.innerHTML = data.email;
                                    let avatar = data.avatar !== null ? data.avatar : 'empty.svg';
                                    avatarElement.src = `${location.protocol}//${location.hostname}/build-classics/img/themes/quizhero/avatars/${avatar}`;
                                }

                                closeCreateAccountModal();
                            });
                        }
                        else {
                            if (!response.ok) {
                                return response.json().then(error => {
                                    throw new Error();
                                });
                            }
                            return response.json();
                        }
                    })
                    .catch(error => {
                        if (codeElement) {
                            codeElement.parentElement.classList.add('is-invalid');
                        }
                    });
            }

            if (emailElement.disabled === false) {
                fetch(`${loginPath}?email=${btoa(emailElement.value)}`)
                    .then(response => {
                        if (!response.ok) {
                            return response.json().then(error => {
                                throw new Error();
                            });
                        }
                    })
                    .catch((error) => {
                        if (emailElement.disabled === false) {
                            emailElement.parentElement.classList.add('is-invalid');
                        }
                    });
                showNextStep();
            }
        });
    }

    function changeEmailHandler() {
        changeEmailElement.addEventListener('click', function (event) {
            event.preventDefault();

            popupElement.querySelector('form').reset();
            showNextStep();

            modifyEmailElement(false);
        });
    }

    function showNextStep() {
        modifyEmailElement(true);

        firstStepElements.forEach(function (item) {
            item.classList.toggle('hidden');
        });
        secondStepElements.forEach(function (item) {
            item.classList.toggle('hidden');
        });

        initResendTimer();
    }

    function resendCodeHandler() {
        resendCodeElement.addEventListener('click', function (event) {
            event.preventDefault();
            if (!event.target.classList.contains('cursor-not-allowed')) {
                emailElement.parentElement.classList.remove('is-invalid');
                codeElement.parentElement.classList.remove('is-invalid');

                fetch(`${loginPath}?email=${btoa(emailElement.value)}`)
                    .then(response => {
                        if (!response.ok) {
                            return response.json().then(error => {
                                throw new Error();
                            });
                        }
                    })
                    .catch((error) => {
                        if (emailElement.disabled === false) {
                            emailElement.parentElement.classList.add('is-invalid');
                        }
                    });

                codeElement.value = '';
                initResendTimer();
            }
        });
    }

    function modifyEmailElement(disabled) {
        emailElement.disabled = disabled;
        emailElement.classList.toggle('disabled');
        emailElement.parentElement.classList.remove('is-invalid');
        codeElement.parentElement.classList.remove('is-invalid');
    }

    function showCreateAccountPopup() {
        document.addEventListener("click", function (event) {
            const target = event.target.closest("[data-modal-login]");
            if (target) {
                event.preventDefault();
                closeAllPopups();
                disableAds();

                document.dispatchEvent((new CustomEvent('toggleGlobalNav', {})));

                popupElement.classList.toggle('hidden');
            }
        });
    }

    function hideCreateAccountPopup() {
        const closePopupButton = document.querySelector('[data-close-popup]');
        if (!closePopupButton) {
            return
        }
        closePopupButton.addEventListener('click', function (event) {
            event.preventDefault();

            closeCreateAccountModal();
            refreshAds();
        });
    }

    function closeCreateAccountModal() {
        popupElement.classList.add('hidden');
    }

    function initResendTimer() {
        clearInterval(resetCountdownId);
        resendCodeElement.classList.toggle('cursor-not-allowed');
        let timeLeft = 59;
        resendCodeElementTimer.textContent = '01:00';

        resetCountdownId = setInterval(() => {
            const minutes = Math.floor(timeLeft / 60);
            const seconds = timeLeft % 60;

            resendCodeElementTimer.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            timeLeft--;

            if (timeLeft < 0) {
                clearInterval(resetCountdownId);
                resendCodeElementTimer.textContent = "";
                resendCodeElement.classList.toggle('cursor-not-allowed');
            }
        }, 1000);
    }
});